// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDT5YeWrWSJuHk4hbt6-LRfSY0dauprjww",
    authDomain: "liceo-guggenheim.firebaseapp.com",
    databaseURL: "https://liceo-guggenheim.firebaseio.com",
    projectId: "liceo-guggenheim",
    storageBucket: "",
    messagingSenderId: "265292949992"
  }
};



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/environments/environment.ts